import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type RegionState = {
  confirmedRegion: string
  setConfirmedRegion: (region: string) => void
  clearConfirmedRegion: () => void
}

const useRegionStore = create<RegionState>()(
  persist(
    (set) => ({
      confirmedRegion: '',
      setConfirmedRegion: (region) => set({ confirmedRegion: region }),
      clearConfirmedRegion: () => set({ confirmedRegion: '' }),
    }),
    { name: 'region-storage' }
  )
)

export default useRegionStore
